import React, { useState, useEffect } from "react";
import CrossIcon from "../../../Assests/Dashboard/cross.svg";
import {
  fetchEmployeeListsData,
  deleteEmployee,
} from "../../../Redux/features/StoreSettings/AddEmployee/AddEmployeeSlice";
import { useSelector, useDispatch } from "react-redux";
import AddIcon from "../../../Assests/Category/addIcon.svg";

import "../../../Styles/Settings/Employee.css";

import AddEmployeeFormLogic from "../../StoreSetting/AddEmployee/AddEmployeeFormLogic";

import { useAuthDetails } from "../../../Common/cookiesHelper";
import { Grid } from "@mui/material";
import DraggableTable from "../../../reuseableComponents/DraggableTable";

import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import DeleteModal from "../../../reuseableComponents/DeleteModal";
import CircularProgress from "@mui/material/CircularProgress";
import PasswordShow from "../../../Common/passwordShow";
import AddEmployeeModal from "./AddEmployeeModal";
import { fetchPermissions } from "../../../Redux/features/Authentication/permissionsSlice";
import { PERMISSIONS } from "../../../Constants/permission";
import { SkeletonTable } from "../../../reuseableComponents/SkeletonTable";

import { Link } from "react-router-dom";
import Permission from "../../../Assests/Employee/Permission.svg";
import DeleteIcon from "../../../Assests/Category/deleteIcon.svg";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import NoDataFound from "../../../reuseableComponents/NoDataFound";
import AssignStoreDetails from "./AssignStoreDetails";
import EditEmployeeModal from "./EditEmployeeModal";
import SelectDropDownWithCheckBox from "../../../reuseableComponents/SelectDropDownWithCheckBox";
import useMultiSelect from "../../../hooks/useMultiSelect";
import InputTextSearch from "../../../reuseableComponents/InputTextSearch";
import Config from "../../../Constants/Config";
import axios from "axios";
import { formatPhoneNumber } from "../../../helperFunctions/formatPhoneNumber";
import { ciUrl } from "../../../Constants/nodeCi";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--qv-bg-253338, #253338)",
    color: theme.palette.common.white,
    fontFamily: "CircularSTDMedium !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    paddingTop: "12px",
    paddingLeft: "12px",
    paddingRight: "1px",
    fontFamily: "CircularSTDBook !important",
  },
  [`&.${tableCellClasses.table}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {},
  "& td, & th": {
    border: "none",
  },
}));

const EmployeeList = ({ setVisible, setEmployeeId }) => {
  const employeeListDataState = useSelector((state) => state.employeelistData);
  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } =
    PasswordShow();
  const [employeeList, setemployeeList] = useState([]);
  console.log("employeeList", employeeList);
  const dispatch = useDispatch();
  const { permissions, status, error } = useSelector(
    (state) => state.permissions
  );
  // const [allemployee, setallemployee] = useState([]);
  const [states, setstates] = useState([]);
  // const [value, setValue] = useState();
  // const [inputValue, setInputValue] = useState('');
  // const [showModal, setShowModal] = useState(false);
  const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData, GetSessionLogin } =
    useAuthDetails();
  let AuthDecryptDataDashBoardJSONFormat = LoginGetDashBoardRecordJson;
  const merchant_id = AuthDecryptDataDashBoardJSONFormat?.data?.merchant_id;
  const login_user_type = AuthDecryptDataDashBoardJSONFormat?.login_type;
  const login_user_email = AuthDecryptDataDashBoardJSONFormat?.data?.email;
  // const employee_id = AuthDecryptDataDashBoardJSONFormat?.employee_id;
  let employee_id = 0;
  if (localStorage.getItem("emp_id")) {
    employee_id = localStorage.getItem("emp_id");
  }

  useEffect(() => {
    const emp_id = window.localStorage.getItem("emp_id");
    if (emp_id !== null && emp_id !== undefined) {
      const requestData = { emp_id: emp_id };
      dispatch(fetchPermissions(requestData));
    }
  }, [dispatch]);
  const {
    handleAddEmployeeInput,
    handlePhoneInput,
    handlePinInput,
    handleZipInput,
    values,
    handleAddEmployee,
    submitmessage,
    showModal,
    setShowModal,
    scrollRef,
    setsubmitmessage,
    handleKeyPress,
    loader,
    // handleBlur,
  } = AddEmployeeFormLogic({ employeeList });

  const getEmployeeListData = async (data) => {
    try {
      await dispatch(fetchEmployeeListsData(data)).unwrap();
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
  };

  useEffect(() => {
    let data = {
      merchant_id: merchant_id,
      login_user_email: login_user_email,
      employee_id: employee_id,
      login_user_type: login_user_type,
      ...userTypeData,
    };
    if (data) {
      getEmployeeListData(data);
    }
  }, []);

  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
    values.firstname = "";
    values.lastname = "";
    values.email = "";
    values.phone = "";
    values.pin = "";
    values.wages = "";
    values.address_line_1 = "";
    values.city = "";
    values.zipcode = "";
    values.state = "";

    values.errors.firstname = "";
    values.errors.lastname = "";
    values.errors.email = "";
    values.errors.phone = "";
    values.errors.pin = "";
    values.errors.wages = "";
    values.errors.address_line_1 = "";
    values.errors.city = "";
    values.errors.zipcode = "";
    values.errors.state = "";
  };

  useEffect(() => {
    if (
      !employeeListDataState.loading &&
      employeeListDataState.employeelistData
    ) {
      console.log("employeeListDataState", employeeListDataState);
      setemployeeList(employeeListDataState.employeelistData);
      const all_states = employeeListDataState.states;
      setstates(all_states);
    }
  }, [
    employeeListDataState,
    employeeListDataState.loading,
    employeeListDataState.employeelistData,
  ]);

  const [deleteEmployeeId, setDeleteEmployeeId] = useState(null);
  const [deleteEmployeeMerchantId, setDeleteEmployeeMerchantId] =
    useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  let allStoresData = LoginAllStore?.data2?.stores;
  function handleReturnStoreNamesUsingMerchantId(merchantIds) {
    if (!merchantIds) return [];
    const merchantIdArray = merchantIds
      .split(",")
      .map((id) => id.toUpperCase());

    const allStores =
      JSON.parse(localStorage.getItem("AllStore")) || allStoresData || [];
    // if(!Array.isArray(allStores)){
    //   console.error("AllStore is not an array in localStore");
    //   return []
    // }
    const filteredStores = allStores.filter((store) =>
      merchantIdArray.includes(store.merchant_id)
    );
    return filteredStores || [];
  }

  const handleDeleteEmployee = (id, deleteMerchantId) => {
    setDeleteEmployeeId(id);
    setDeleteEmployeeMerchantId(deleteMerchantId);
    setDeleteModalOpen(true);
  };
  const confirmDeleteCategory = async () => {
    if (deleteEmployeeId && deleteEmployeeMerchantId) {
      const data = {
        employee_id: deleteEmployeeId,
        merchant_id: deleteEmployeeMerchantId,
        ...userTypeData,
      };
      if (data) {
        const response = await dispatch(deleteEmployee(data)).unwrap();
        ToastifyAlert("Deleted Successfully", "success");
      }
    }
    setDeleteEmployeeId(null);
    setDeleteModalOpen(false);
  };

  const myStyles = {
    // width: "58rem",
    position: "absolute",
    top: "47%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "unset",
  };

  function handleEmplyeeClick(id) {
    setVisible("EmployeePermission");
    setEmployeeId(id);
  }

  const [storeOptions, setStoreOptions] = useState([]);
  const [seletedRoles, setSeletedRoles] = useState([]);
  const {
    selectedItems: selectedStoreList,
    allOptionSelected: allStoreSelected,
    handleOptionClick: handleStoreClick,
  } = useMultiSelect(storeOptions);
  const {
    selectedItems: selectedRoleList,
    allOptionSelected: allRoleSelected,
    handleOptionClick: handleRoleClick,
  } = useMultiSelect(seletedRoles);
  useEffect(() => {
    let getStoreList = localStorage.getItem("AllStore") ?? [];
    const parsedData = JSON.parse(getStoreList);
    // setStoreOptions(parsedData);
    loadStoreOptions();
  }, []);
  const loadStoreOptions = async (inputValue) => {
    try {
      const payload = {
        name: inputValue || "", // filter by input
        merchant_id: merchant_id,
        email: userTypeData?.login_type === "superadmin" ? LoginGetDashBoardRecordJson?.data?.email : GetSessionLogin?.username,
        ...userTypeData,
      };
      const { token, ...splitData } = payload;
      const response = await axios.post(
        ciUrl(Config.GET_ALL_MANAGER_STORES),
        splitData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${LoginGetDashBoardRecordJson?.token}`,
          },
        }
      );
      if (response.data.status && response.data.data.length > 0) {
        // Map data to { value, label } format for AsyncSelect
        const options = response.data.data.map((store) => ({
          value: store.merchant_id,
          merchant_id: store.merchant_id,
          name: store.name,
          label: store.name,
          raw: store,
          id: store.merchant_id,
        }));
        setStoreOptions(options);
      } else {
        return [];
      }
    } catch (err) {
      console.error("Error fetching stores", err);
      return [];
    }
  };
  useEffect(() => {
    const AllRoles =
      employeeListDataState?.employeelistData
        ?.map((store) => store.role)
        .filter((i) => i) || [];
    const uniqueTitleRoles = [...new Set(AllRoles)].map((role, index) => ({
      id: index + 1,
      name: role.charAt(0).toUpperCase() + role.slice(1).toLowerCase(),
    }));
    setSeletedRoles(uniqueTitleRoles);
  }, [employeeListDataState]);
  const [searchRecord, setSearchRecord] = useState("");
  const handleSearchInputChange = (value) => {
    setSearchRecord(value);
  };

  useEffect(() => {
    // if (login_user_type === "superadmin") {
    //   setemployeeList(employeeListDataState.employeelistData);
    //   return;
    // }
    if (
      selectedStoreList.length === 0 &&
      selectedRoleList.length === 0 &&
      searchRecord.trim().length === 0
    ) {
      setemployeeList(employeeListDataState.employeelistData);
      return;
    }
    // When some stores are selected, filter employees by matching merchant_id
    const selectedStoreIds = selectedStoreList.map(
      (store) => store?.merchant_id
    );
    const selectedRoles = selectedRoleList.map((store) =>
      store?.name?.toLowerCase()
    );
    const filteredEmployees = employeeListDataState.employeelistData.filter(
      (employee) => {
        const employeeStores = employee.assigned_store?.split(",") || [];
        // return employeeStores.some((storeId) =>
        //   selectedStoreIds.includes(storeId)
        // );
        const matchesStore =
          selectedStoreIds.length === 0 ||
          employeeStores.some((storeId) => selectedStoreIds.includes(storeId));
        const matchesRole =
          selectedRoles.length === 0 ||
          selectedRoles.includes(employee.role) ||
          allRoleSelected;
        const nullRoleEmp = employee.role === null;
        const fullName =
          `${employee.f_name ?? ""} ${employee.l_name ?? ""}`.trim();
        const matchesSearch =
          searchRecord.trim().length === 0 ||
          employee.email?.toLowerCase().includes(searchRecord.toLowerCase()) ||
          fullName.toLowerCase().includes(searchRecord.toLowerCase());

        return matchesStore && matchesRole && matchesSearch;
      }
    );
    setemployeeList(filteredEmployees);
  }, [
    selectedStoreList,
    selectedRoleList,
    employeeListDataState.employeelistData,
    searchRecord,
  ]);

  return (
    <>
      {storeOptions.length > 1 && (
        <Grid container className="box_shadow_div">
          <Grid item xs={12}>
            <Grid container sx={{ px: { xs: 1, sm: 2.5 }, pt: 1 }}>
              <Grid xs={12} sm={6} md={4}>
                <div className="heading">Filter by</div>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              sx={{ px: { xs: 1, sm: 2.5 }, pb: 2.5 }}
            >
              <Grid item xs={12} sm={6} md={4}>
                <label
                  className="q-details-page-label !mb-1"
                  htmlFor="storeNameFilter"
                >
                  Employee
                </label>
                <InputTextSearch
                  className=""
                  type="text"
                  handleChange={handleSearchInputChange}
                  value={searchRecord}
                  autoComplete="off"
                  placeholder="Search by Employee Name or Email"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <label
                  className="q-details-page-label"
                  htmlFor="storeNameFilter"
                >
                  Assigned Store
                </label>
                <SelectDropDownWithCheckBox
                  className="mt-1"
                  options={storeOptions}
                  heading={"All"}
                  title="name"
                  label={storeOptions?.length ? "Assigned Store" : "All"}
                  onClickHandler={handleStoreClick}
                  selectedOption={selectedStoreList}
                  allOptionSelected={allStoreSelected}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <label className="q-details-page-label" htmlFor="roleFilter">
                  Roles
                </label>
                <SelectDropDownWithCheckBox
                  className="mt-1"
                  options={seletedRoles}
                  heading={"All"}
                  title="name"
                  label={seletedRoles?.length ? "Roles" : "All"}
                  onClickHandler={handleRoleClick}
                  selectedOption={selectedRoleList}
                  allOptionSelected={allRoleSelected}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}

      <Grid container className="box_shadow_div employee-table-for-android">
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{
              borderBottom: "1px solid var(--qv-bd-e8e8e8, #E8E8E8)",
            }}
          >
            <Grid item>
              <Grid
                sx={{ px: { xs: 1, sm: 2.5 } }}
                className="q-category-bottom-header"
              >
                <span>Employees</span>
              </Grid>
            </Grid>
            <Grid item className="add-employee-android">
              <Grid container direction="row" alignItems="center">
                <Grid item>
                  <Grid
                    sx={{ px: { xs: 1, sm: 2.5 } }}
                    className="q-category-bottom-header"
                  >
                    {/* <p onClick={openModal}>
                      Add Employee <img src={AddIcon} alt="add-icon" />

                    </p> */}
                    {!permissions.length ||
                    permissions.includes(
                      PERMISSIONS.MENU_MANAGE_STORE_ADD_OR_EDIT
                    ) ? (
                      <AddEmployeeModal
                        states={states}
                        employeeList={employeeList}
                        setVisible={setVisible}
                        setEmployeeId={setEmployeeId}
                      />
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {employeeListDataState.loading ? (
            <SkeletonTable
              columns={[
                "Sort",
                "Employee",
                "Phone",
                "E-mail",
                "Assigned Store",
                "Pin",
                "Role",
                "Action",
                "",
                "",
              ]}
            />
          ) : (
            <>
              {/* For Dragable Table Start  */}
              {/* <DraggableTable
              tableHead={[
                "Sort",
                "Employee",
                "Phone",
                "E-mail",
                "Assigned Store",
                "Pin",
                "Role",
                "Action",
                "",
                "",
              ]}
              tableRow={employeeList}
              setFunction={setemployeeList}
              employeeTable={true}
              states={states}
              editBtnEmployee={{
                editButtonEnableEmployee: true,
                editButtonurlEmployee: "/store-settings/permission/",
              }}
              setVisible={setVisible}
              setEmployeeId={setEmployeeId}
              deleteButton={
                !permissions.length ||
                permissions.indexOf(PERMISSIONS.MENU_DELETE_EMPLOYEES) > -1
                  ? {
                      deleteButtonEnable: true,
                      deleteButtonFun: handleDeleteEmployee,
                    }
                  : undefined
              }
              //   table={"collection"}
              className="q-category-bottom-categories-single-category"
              handleReturnStoreNamesUsingMerchantId={
                handleReturnStoreNamesUsingMerchantId
              }
            /> */}

              {/* For Dragable Table End  */}

              {/* For New Table start  */}

              <TableContainer>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Employee</StyledTableCell>
                      <StyledTableCell>Phone</StyledTableCell>
                      <StyledTableCell>E-mail</StyledTableCell>
                      <StyledTableCell className="whitespace-nowrap">
                        Assigned Store
                      </StyledTableCell>
                      {/* <StyledTableCell>Pin</StyledTableCell> */}
                      <StyledTableCell>Role</StyledTableCell>
                      <StyledTableCell colSpan={3}>Action</StyledTableCell>
                      {/* <StyledTableCell></StyledTableCell>
                      <StyledTableCell></StyledTableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {employeeList && employeeList.length >= 1 ? (
                      employeeList.map((row) => (
                        <StyledTableRow key={row.id}>
                          <StyledTableCell>
                            {" "}
                            {row?.f_name} {row?.l_name}
                          </StyledTableCell>
                          <StyledTableCell>
                            {" "}
                            {formatPhoneNumber(row?.phone)}
                          </StyledTableCell>
                          <StyledTableCell> {row?.email}</StyledTableCell>
                          <StyledTableCell>
                            <AssignStoreDetails
                              handleReturnStoreNamesUsingMerchantId={
                                handleReturnStoreNamesUsingMerchantId
                              }
                              storeList={row}
                            />
                          </StyledTableCell>
                          {/* <StyledTableCell> {+row?.is_admin === 1 ? null : row?.pin}</StyledTableCell> */}
                          <StyledTableCell> {row?.role}</StyledTableCell>
                          {!permissions?.length ||
                          (permissions?.includes(
                            PERMISSIONS?.MENU_MANAGE_STORE_ACCESS_PERMISSION
                          ) &&
                            +row?.is_admin !== 1) ? (
                            <>
                              <StyledTableCell>
                                <img
                                  onClick={() => handleEmplyeeClick(row?.id)}
                                  alt="Permission-icon"
                                  src={Permission}
                                  className=" cursor-pointer"
                                />
                              </StyledTableCell>
                            </>
                          ) : null}

                          {(!permissions.length ||
                            (permissions.includes(
                              PERMISSIONS.MENU_MANAGE_STORE_ADD_OR_EDIT
                            ) &&
                              +row?.is_admin !== 1)) && (
                            <>
                              <StyledTableCell>
                                <EditEmployeeModal
                                  employee={row}
                                  states={states}
                                  employeeList={employeeList}
                                />
                              </StyledTableCell>
                            </>
                          )}

                          <StyledTableCell>
                            {!permissions.length ||
                            (permissions.includes(
                              PERMISSIONS.MENU_DELETE_EMPLOYEES
                            ) &&
                              +row?.is_admin !== 1) ? (
                              <>
                                <img
                                  className="cursor-pointer"
                                  src={DeleteIcon}
                                  alt="delete-icon"
                                  onClick={() =>
                                    handleDeleteEmployee(
                                      row?.id,
                                      row?.merchant_id
                                    )
                                  }
                                />
                              </>
                            ) : null}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    ) : (
                      <>
                        <StyledTableRow>
                          <StyledTableCell colSpan={100}>
                            <NoDataFound table={true} />
                          </StyledTableCell>
                        </StyledTableRow>
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* For New Table start  */}
            </>
          )}
        </Grid>
      </Grid>
      <DeleteModal
        headerText="Employee"
        open={deleteModalOpen}
        onClose={() => {
          setDeleteModalOpen(false);
        }}
        onConfirm={confirmDeleteCategory}
      />

      {/* {showModal && (
        <>
          <div
            className="q-custom-modal-container  box_shadow_div"
            id="addemployee"
          >
            <div
              className="q-custom-modal-content modal_custom"
              style={myStyles}
            >
              <div
                className="q-add-categories-section-header"
                style={{ justifyContent: "space-between" }}
              >
                <span style={{ cursor: "unset" }}>Add Employee</span>
                <div className="float-right">
                  <img
                    src={CrossIcon}
                    alt="icon"
                    className="quic-btn-cancle w-6 h-6 cursor-pointer"
                    onClick={closeModal}
                  />
                </div>
              </div>

              <div className="p-6">
                <div className="qvrow">
                  <div className="col-qv-4">
                    <div className="input_area">
                      <label>
                        First Name <span className="Asterisk_error">*</span>
                      </label>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--qv-bd-000000, black)",
                            },
                          },
                        }}
                        id="outlined-basic"
                        type="text"
                        name="firstname"
                        placeholder="First Name"
                        value={values.firstname}
                        onChange={handleAddEmployeeInput}
                        className="q-custom-input-field"
                        variant="outlined"
                        size="small"
                      />
                      <span className="input-error">
                        {values.errors.firstname !== ""
                          ? values.errors.firstname
                          : ""}
                      </span>
                    </div>
                  </div>
                  <div className="col-qv-4">
                    <div className="input_area">
                      <label>Last Name</label>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--qv-bd-000000, black)",
                            },
                          },
                        }}
                        id="outlined-basic"
                        type="text"
                        name="lastname"
                        placeholder="Last Name"
                        value={values.lastname}
                        onChange={handleAddEmployeeInput}
                        className="q-custom-input-field"
                        variant="outlined"
                        size="small"
                      />
                      <span className="input-error">
                        {values.errors.lastname !== ""
                          ? values.errors.lastname
                          : ""}
                      </span>
                    </div>
                  </div>
                  <div className="col-qv-4">
                    <div className="input_area">
                      <label>
                        Email Address <span className="Asterisk_error">*</span>
                      </label>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--qv-bd-000000, black)",
                            },
                          },
                        }}
                        id="outlined-basic"
                        type="text"
                        name="email"
                        placeholder="Email"
                        value={values.email}
                        onChange={handleAddEmployeeInput}
                        className="q-custom-input-field"
                        variant="outlined"
                        size="small"
                      />
                      <span className="input-error">
                        {values.errors.email !== "" ? values.errors.email : ""}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="qvrow">
                  <div className="col-qv-4">
                    <div className="input_area">
                      <label>
                        Phone Number <span className="Asterisk_error">*</span>
                      </label>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--qv-bd-000000, black)",
                            },
                          },
                        }}
                        id="outlined-basic"
                        type="text"
                        name="phone"
                        placeholder="Phone"
                        value={values.phone}
                        inputProps={{ maxLength: 10 }}
                        // onChange={handlePhoneInput}
                        onChange={handleAddEmployeeInput}
                        className="q-custom-input-field"
                        variant="outlined"
                        size="small"
                        onKeyPress={handleKeyPress}
                      />
                      <span className="input-error">
                        {values.errors.phone !== "" ? values.errors.phone : ""}
                      </span>
                    </div>
                  </div>
                  <div className="col-qv-4">
                    <div className="input_area">
                      <label>
                        PIN <span className="Asterisk_error">*</span>
                      </label>
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--qv-bd-000000, black)",
                            },
                          },
                        }}
                        id="outlined-basic"
                        type="text"
                        name="pin"
                        placeholder="Pin"
                        value={values.pin}
                        inputProps={{ maxLength: 4 }}
                        onChange={handleAddEmployeeInput}
                        // onChange={handlePinInput}
                        className="q-custom-input-field"
                        variant="outlined"
                        size="small"
                        onKeyPress={handleKeyPress}
                        // onBlur={() => handleBlur("pin")}
                      />
                      <span className="input-error">
                        {values.errors.pin !== "" ? values.errors.pin : ""}
                      </span>
                    </div>
                  </div>
                  <div className="col-qv-4">
                    <div className="input_area">
                      <label>Wages ($/hr)</label>

                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--qv-bd-000000, black)",
                            },
                          },
                        }}
                        id="outlined-basic"
                        type="text"
                        name="wages"
                        placeholder="Wages Per Hour"
                        value={values.wages}
                        onChange={handleAddEmployeeInput}
                        className="q-custom-input-field"
                        variant="outlined"
                        size="small"
                      />
                      <span className="input-error">
                        {values.errors.wages !== "" ? values.errors.wages : ""}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="qvrow">
                  <div className="col-qv-12">
                    <div className="input_area">
                      <label>Address</label>

                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--qv-bd-000000, black)",
                            },
                          },
                        }}
                        id="outlined-basic"
                        type="text"
                        name="address_line_1"
                        placeholder="Address"
                        value={values.address_line_1}
                        onChange={handleAddEmployeeInput}
                        className="q-custom-input-field"
                        variant="outlined"
                        size="small"
                      />
                      <span className="input-error">
                        {values.errors.address_line_1 !== ""
                          ? values.errors.address_line_1
                          : ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-qv-4">
                    <div className="input_area">
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--qv-bd-000000, black)",
                            },
                          },
                        }}
                        id="outlined-basic"
                        type="text"
                        name="city"
                        placeholder="City"
                        value={values.city}
                        onChange={handleAddEmployeeInput}
                        className="q-custom-input-field"
                        variant="outlined"
                        size="small"
                      />
                      <span className="input-error">
                        {values.errors.city !== "" ? values.errors.city : ""}
                      </span>
                    </div>
                  </div>
                  <div className="col-qv-4">
                    <div className="input_area">
                      <TextField
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--qv-bd-000000, black)",
                            },
                          },
                        }}
                        id="outlined-basic"
                        type="text"
                        name="zipcode"
                        placeholder="Zip"
                        value={values.zipcode}
                        inputProps={{ maxLength: 5 }}
                        onChange={handleZipInput}
                        className="q-custom-input-field"
                        variant="outlined"
                        size="small"
                      />
                      <span className="input-error">
                        {values.errors.zipcode !== ""
                          ? values.errors.zipcode
                          : ""}
                      </span>
                    </div>
                  </div>
                  <div className="col-qv-4">
                    <div className="input_area addEmployeeState">
                      <Select
                        size="small"
                        name="state"
                        value={values.state}
                        onChange={handleAddEmployeeInput}
                        className="q-custom-input-field"
                        displayEmpty
                      >
                        <MenuItem value="">Select a state</MenuItem>
                        {states &&
                          states.map((state, index) => (
                            <MenuItem key={index} value={state.State}>
                              {state.State}
                            </MenuItem>
                          ))}
                      </Select>

                      <span className="input-error">
                        {values.errors.state !== "" ? values.errors.state : ""}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="q-add-categories-section-middle-footer plr0">
                  <button
                    onClick={handleAddEmployee}
                    className="quic-btn quic-btn-save attributeUpdateBTN"
                    disabled={loader}
                  >
                    {loader ? (
                      <>
                        <CircularProgress
                          color={"inherit"}
                          className="loaderIcon"
                          width={15}
                          size={15}
                        />
                        Add
                      </>
                    ) : (
                      "Add"
                    )}
                  </button>
                  <button
                    onClick={closeModal}
                    className="quic-btn quic-btn-cancle"
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}
    </>
  );
};

export default EmployeeList;
